var map = {
	"./graphics/logo.png": 774,
	"./graphics/logoUport.png": 775,
	"./graphics/logoUportSmall.png": 776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/graphics\/[^\/]+\.(jpg|jepg|png|gif)$
// module id = 773
// module chunks = 1 3